import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Tabs } from "antd";

import { TabAnimalPaneContent } from "../../styles";
import TabAnimalLotHistory from "./tabAnimalLotHistory";
import TabAnimalPicketHistory from "./tabAnimalPicketHistory";

const { TabPane } = Tabs;

function TabAnimalHistory({ tabAnimalPane }) {
  const [activeHistoryTab, setActiveHistoryTab] = useState("lots");

  const {
    app: { translation },
  } = useSelector((state) => state);

  return (
    <TabAnimalPaneContent active={tabAnimalPane === 8 ? true : false}>
      <div className="cardBovexo">
        <Tabs
          activeKey={activeHistoryTab}
          onChange={(key) => setActiveHistoryTab(key)}
          type="card"
        >
          <TabPane
            tab={translation.animal.details.animalHistory.lots}
            key="lots"
          >
            <TabAnimalLotHistory />
          </TabPane>
          <TabPane
            tab={translation.animal.details.animalHistory.pickets}
            key="pickets"
          >
            <TabAnimalPicketHistory />
          </TabPane>
        </Tabs>
      </div>
    </TabAnimalPaneContent>
  );
}

export default TabAnimalHistory;
